// extracted by mini-css-extract-plugin
export default {"root":"szYy2","message":"_8ztlW","button":"uM4Pe"};